import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Product = (props) => {
  return (
    <FormGroup controlId="product">
      <Col componentClass={ControlLabel} sm={2}>
        Product
      </Col>
      <Col sm={10}>
        <select className="custom-select" onChange={props.handleChangeProduct} value={props.productValue}>
          <option value="">Please Select</option>
          <option value="cv">SMARTDRIVE COMMERCIAL VEHICLE</option>
          <option value="pv">SMARTDRIVE PRIVATE CAR</option>
        </select>
      </Col>
    </FormGroup>
  )
}

Product.propTypes = {
  handleChangeProduct: PropTypes.func,
  productValue: PropTypes.string
};

export default Product;



// WEBPACK FOOTER //
// ./src/app/components/product/Product.js